import { useRef } from "react";
import "./CustomFileUploadBtn.scss";
import { showToastMessage } from "../../../utils/commonFunctions";

const CustomFileUploadBtn = ({ icon, postFileToMinio }) => {

  const inputRef = useRef(null);

  //HANDLE FILE UPLOAD TO MINIO
  const handleFileUpload = async (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;
    try {
      const fileSize = selectedFile.size;
      const maxSize = 100 * 1024 * 1024; // 100MB
      if(fileSize  === 0){
        showToastMessage('error', 'File is empty. Please upload a valid file.');
      } else if (fileSize <= maxSize) {
        await postFileToMinio(selectedFile);
      } else {
        showToastMessage('error', 'File exceeds the size limit (100 MB)');
      }
    } catch (error) {
      showToastMessage('error', 'File format not supported or upload failed');
    } finally {
      e.target.value = ''; // Reset the input value to allow re-uploading the same file
    }
  }

  return (
    <div className="file-upload-container">
      <div className="upload-wrapper">
        <button className="upload-button" onClick={() => inputRef.current.click()}>{icon}</button>
      </div>
      <input
        type="file"
        ref={inputRef}
        onChange={(e) => { handleFileUpload(e) }}
        className="hidden-file-input"
      />
    </div>
  );
};

export default CustomFileUploadBtn;
